import React from 'react';
import { Link } from 'react-router-dom';

export const Footer = () => {
    return (
        <div className="container">
            <footer className="py-5 my-5 border-top">
                <div className="row">
                    <div className="col-lg-3 col-sm-6 mb-3">
                        <p className="h5">Navigation</p>
                        <ul className="nav flex-column">
                            <li className="nav-item mb-2"><Link to={`/`} className="nav-link p-0 text-muted">Home</Link></li>
                            <li className="nav-item mb-2"><a href="https://store.woodyguthrie.org/" className="nav-link p-0 text-muted">Store</a></li>
                        </ul>
                    </div>
                    <div className="col-lg-5 col-sm-6 mb-3">
                        <p className="h5">Info</p>
                        <div className="container">
                            <div className="row">
                                <div className="col-auto p-0"><i className="bi-house-fill"></i></div>
                                <div className="col px-2">125-131 E. Main Street,<br/>Suite #200 Mt. Kisco, NY 10549</div>
                            </div>
                            <div className="row">
                                <div className="col-auto p-0"><i className="bi-telephone-fill"></i></div>
                                <div className="col px-2">(914) 241-3844</div>
                            </div>
                            <div className="row">
                                <div className="col-auto p-0"><i className="bi-envelope-fill"></i></div>
                                <div className="col px-2"><a href="mailto:info@woodyguthrie.org" target="_blank" rel="noreferrer">info@woodyguthrie.org</a></div>
                            </div>
                        </div>
                        <br/>
                        <p className="h5">Our Friends</p>
                        <ul className="nav flex-column">
                            <li className="nav-item mb-2"><a href="https://woodyguthriecenter.org" target="_blank" rel="noreferrer" className="nav-link p-0 text-muted">Woody Guthrie Center &amp; Archives,
                                OK</a></li>
                            <li className="nav-item mb-2"><a href="https://guthriecenter.org/" target="_blank" rel="noreferrer" className="nav-link p-0 text-muted">Guthrie Center at the Old Trinity Church,
                                MA</a></li>
                            <li className="nav-item mb-2"><a href="https://www.guthriegreen.com/" target="_blank" rel="noreferrer" className="nav-link p-0 text-muted">Guthrie Green Park</a></li>
                            <li className="nav-item mb-2"><a href="https://www.woodyfest.com/" target="_blank" rel="noreferrer" className="nav-link p-0 text-muted">Woody Guthrie Festival</a></li>
                            <li className="nav-item mb-2"><a href="https://hdsa.org/" target="_blank" rel="noreferrer" className="nav-link p-0 text-muted">Huntington's Disease Society of America</a></li>
                        </ul>
                    </div>
                    <div className="col-lg-4 col-sm-6 mb-3">
                        <div className="container">
                            <div className="row">
                                <div className="col-auto">
                                    <img src="./img/WGP-2023_logo_trans_100x100.webp" width="100" height="100" alt="Woody Guthrie Publications, Inc."/>
                                </div>
                                <div className="col-auto">
                                    <p className="h5">Follow Us</p>
                                    <ul className="nav flex-row">
                                        <li className="nav-item me-3"><a href="https://www.facebook.com/woodyguthriepage/" target="_blank" rel="noreferrer" alt="Follow Us on Facebook"
                                                                         aria-label="Follow Us on Facebook"><i className="bi-facebook" alt="Follow Us on Facebook"></i></a></li>
                                        <li className="nav-item me-3"><a href="https://open.spotify.com/artist/4rAgFKtlTr66ic18YZZyF1" target="_blank" rel="noreferrer" alt="Find Us on Spotify"
                                                                         aria-label="Find Us on Spotify"><i className="bi-spotify" alt="Find Us on Spotify"></i></a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col">
                        <p className="text-muted text-center">Copyright &copy; 2001-<span id="footerCopyrightYear">2024</span> Woody Guthrie Publications, Inc.</p>
                    </div>
                </div>
            </footer>
        </div>
    );
};
